export default {
    addGroup: 'グループに追加',
    clientCount: '取引先数',
    createGroup:
        'まだグループは作成されていません。<0>こちらから作成</0>いただけます。',
    example: 'これはスーパーな一例です',
    groupName: 'グループ名',
    memberCount: 'メンバー数',
    removeGroup: 'グループから削除',
    subheader:
        '取引先に担当グループを設定すると、取引先や関連書類、レポートが所属メンバーにのみ表示されます。',
};
